<template>
  <a
    href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbEl4WjFaa1lUWTNXUzhyVG1OVFVIbzNSVTR3VTJjOVBTSXNJblpoYkhWbElqb2lRVmxqZDJrMWRuRmtSaTlOV0ZGbFZ6SktVVnA2WnowOUlpd2liV0ZqSWpvaVpqbGpOVGN6WkdGa01UVm1aRGt5TlRoaVlqZ3dNRGcwWWpabVpXTTFNVGRpWldSaE1UUmhOVFprWVRZM09UUTJOR0kwTlRjMk5USTVNMkU1WkRObE9TSXNJblJoWnlJNklpSjk="
    target="_blank"
  >
    <img
      src="../images/GCB_Seal.svg"
      loading="lazy"
      :width="imageSize.width"
      :height="imageSize.height"
      alt="License"
      class="licence"
    />
  </a>
</template>

<script setup lang="ts">
const { size = 'l' } = defineProps<{
  size?: 's' | 'l'
}>()

const imageSize = computed(() =>
  size === 's'
    ? {
        width: 99,
        height: 56,
      }
    : {
        width: 112,
        height: 64,
      },
)
</script>

<style scoped>
.licence {
  border-radius: var(--border-radius-150);
}
</style>
